import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "row": "registration-53018bea-row-WXUgJq",
  "wideOffset6": "registration-53018bea-wideOffset6-WXUgJq",
  "defaultOffset4": "registration-53018bea-defaultOffset4-WXUgJq",
  "defaultOffset10": "registration-53018bea-defaultOffset10-WXUgJq",
  "tinyOffset2": "registration-53018bea-tinyOffset2-WXUgJq",
  "tinyOffset9": "registration-53018bea-tinyOffset9-WXUgJq",
  "wideOffset5": "registration-53018bea-wideOffset5-WXUgJq",
  "confined1": "registration-53018bea-confined1-WXUgJq",
  "xwideOffset5": "registration-53018bea-xwideOffset5-WXUgJq",
  "default1": "registration-53018bea-default1-WXUgJq",
  "tiny1": "registration-53018bea-tiny1-WXUgJq",
  "confined2": "registration-53018bea-confined2-WXUgJq",
  "col": "registration-53018bea-col-WXUgJq",
  "confinedOffset9": "registration-53018bea-confinedOffset9-WXUgJq",
  "xwide5": "registration-53018bea-xwide5-WXUgJq",
  "confinedOffset0": "registration-53018bea-confinedOffset0-WXUgJq",
  "wideOffset2": "registration-53018bea-wideOffset2-WXUgJq",
  "xwideOffset0": "registration-53018bea-xwideOffset0-WXUgJq",
  "xwideOffset1": "registration-53018bea-xwideOffset1-WXUgJq",
  "defaultOffset9": "registration-53018bea-defaultOffset9-WXUgJq",
  "xwide1": "registration-53018bea-xwide1-WXUgJq",
  "tinyOffset11": "registration-53018bea-tinyOffset11-WXUgJq",
  "defaultOffset8": "registration-53018bea-defaultOffset8-WXUgJq",
  "confined3": "registration-53018bea-confined3-WXUgJq",
  "tiny8": "registration-53018bea-tiny8-WXUgJq",
  "tinyOffset6": "registration-53018bea-tinyOffset6-WXUgJq",
  "wide1": "registration-53018bea-wide1-WXUgJq",
  "tiny12": "registration-53018bea-tiny12-WXUgJq",
  "confinedOffset2": "registration-53018bea-confinedOffset2-WXUgJq",
  "wide2": "registration-53018bea-wide2-WXUgJq",
  "wideOffset11": "registration-53018bea-wideOffset11-WXUgJq",
  "default2": "registration-53018bea-default2-WXUgJq",
  "default12": "registration-53018bea-default12-WXUgJq",
  "confinedOffset10": "registration-53018bea-confinedOffset10-WXUgJq",
  "defaultOffset11": "registration-53018bea-defaultOffset11-WXUgJq",
  "default9": "registration-53018bea-default9-WXUgJq",
  "default11": "registration-53018bea-default11-WXUgJq",
  "defaultOffset1": "registration-53018bea-defaultOffset1-WXUgJq",
  "tinyOffset8": "registration-53018bea-tinyOffset8-WXUgJq",
  "confined10": "registration-53018bea-confined10-WXUgJq",
  "tinyOffset7": "registration-53018bea-tinyOffset7-WXUgJq",
  "confinedOffset3": "registration-53018bea-confinedOffset3-WXUgJq",
  "wideOffset4": "registration-53018bea-wideOffset4-WXUgJq",
  "xwide2": "registration-53018bea-xwide2-WXUgJq",
  "defaultOffset2": "registration-53018bea-defaultOffset2-WXUgJq",
  "wideOffset9": "registration-53018bea-wideOffset9-WXUgJq",
  "grid": "registration-53018bea-grid-WXUgJq",
  "xwide7": "registration-53018bea-xwide7-WXUgJq",
  "xwide12": "registration-53018bea-xwide12-WXUgJq",
  "xwideOffset4": "registration-53018bea-xwideOffset4-WXUgJq",
  "defaultOffset5": "registration-53018bea-defaultOffset5-WXUgJq",
  "wideOffset3": "registration-53018bea-wideOffset3-WXUgJq",
  "tiny5": "registration-53018bea-tiny5-WXUgJq",
  "xwide3": "registration-53018bea-xwide3-WXUgJq",
  "xwideOffset9": "registration-53018bea-xwideOffset9-WXUgJq",
  "confined4": "registration-53018bea-confined4-WXUgJq",
  "wide8": "registration-53018bea-wide8-WXUgJq",
  "xwide0": "registration-53018bea-xwide0-WXUgJq",
  "xwideOffset3": "registration-53018bea-xwideOffset3-WXUgJq",
  "wide12": "registration-53018bea-wide12-WXUgJq",
  "xwideOffset2": "registration-53018bea-xwideOffset2-WXUgJq",
  "wideGridContainer": "registration-53018bea-wideGridContainer-WXUgJq",
  "confined0": "registration-53018bea-confined0-WXUgJq",
  "confined11": "registration-53018bea-confined11-WXUgJq",
  "wide3": "registration-53018bea-wide3-WXUgJq",
  "xwideOffset7": "registration-53018bea-xwideOffset7-WXUgJq",
  "wideOffset10": "registration-53018bea-wideOffset10-WXUgJq",
  "xwide11": "registration-53018bea-xwide11-WXUgJq",
  "xwideOffset8": "registration-53018bea-xwideOffset8-WXUgJq",
  "default6": "registration-53018bea-default6-WXUgJq",
  "wide9": "registration-53018bea-wide9-WXUgJq",
  "xwide4": "registration-53018bea-xwide4-WXUgJq",
  "defaultOffset6": "registration-53018bea-defaultOffset6-WXUgJq",
  "confined6": "registration-53018bea-confined6-WXUgJq",
  "wide5": "registration-53018bea-wide5-WXUgJq",
  "confined12": "registration-53018bea-confined12-WXUgJq",
  "tiny2": "registration-53018bea-tiny2-WXUgJq",
  "tinyOffset4": "registration-53018bea-tinyOffset4-WXUgJq",
  "confined7": "registration-53018bea-confined7-WXUgJq",
  "tinyOffset0": "registration-53018bea-tinyOffset0-WXUgJq",
  "tinyOffset10": "registration-53018bea-tinyOffset10-WXUgJq",
  "default7": "registration-53018bea-default7-WXUgJq",
  "confinedOffset4": "registration-53018bea-confinedOffset4-WXUgJq",
  "default0": "registration-53018bea-default0-WXUgJq",
  "tinyOffset5": "registration-53018bea-tinyOffset5-WXUgJq",
  "default3": "registration-53018bea-default3-WXUgJq",
  "wideOffset0": "registration-53018bea-wideOffset0-WXUgJq",
  "xwide9": "registration-53018bea-xwide9-WXUgJq",
  "tiny11": "registration-53018bea-tiny11-WXUgJq",
  "default8": "registration-53018bea-default8-WXUgJq",
  "xwideOffset10": "registration-53018bea-xwideOffset10-WXUgJq",
  "default4": "registration-53018bea-default4-WXUgJq",
  "standardGridContainer": "registration-53018bea-standardGridContainer-WXUgJq",
  "confinedOffset6": "registration-53018bea-confinedOffset6-WXUgJq",
  "default10": "registration-53018bea-default10-WXUgJq",
  "wide7": "registration-53018bea-wide7-WXUgJq",
  "confined5": "registration-53018bea-confined5-WXUgJq",
  "wide11": "registration-53018bea-wide11-WXUgJq",
  "confinedOffset7": "registration-53018bea-confinedOffset7-WXUgJq",
  "wideOffset7": "registration-53018bea-wideOffset7-WXUgJq",
  "tinyOffset1": "registration-53018bea-tinyOffset1-WXUgJq",
  "confinedOffset1": "registration-53018bea-confinedOffset1-WXUgJq",
  "xwide6": "registration-53018bea-xwide6-WXUgJq",
  "defaultOffset7": "registration-53018bea-defaultOffset7-WXUgJq",
  "default5": "registration-53018bea-default5-WXUgJq",
  "confined8": "registration-53018bea-confined8-WXUgJq",
  "tiny0": "registration-53018bea-tiny0-WXUgJq",
  "confinedOffset5": "registration-53018bea-confinedOffset5-WXUgJq",
  "wide4": "registration-53018bea-wide4-WXUgJq",
  "defaultOffset3": "registration-53018bea-defaultOffset3-WXUgJq",
  "confinedOffset8": "registration-53018bea-confinedOffset8-WXUgJq",
  "tiny3": "registration-53018bea-tiny3-WXUgJq",
  "wide0": "registration-53018bea-wide0-WXUgJq",
  "wideOffset8": "registration-53018bea-wideOffset8-WXUgJq",
  "tiny4": "registration-53018bea-tiny4-WXUgJq",
  "xwide10": "registration-53018bea-xwide10-WXUgJq",
  "confinedOffset11": "registration-53018bea-confinedOffset11-WXUgJq",
  "confined9": "registration-53018bea-confined9-WXUgJq",
  "wideOffset1": "registration-53018bea-wideOffset1-WXUgJq",
  "tinyOffset3": "registration-53018bea-tinyOffset3-WXUgJq",
  "tiny10": "registration-53018bea-tiny10-WXUgJq",
  "xwideOffset11": "registration-53018bea-xwideOffset11-WXUgJq",
  "xwideOffset6": "registration-53018bea-xwideOffset6-WXUgJq",
  "tiny9": "registration-53018bea-tiny9-WXUgJq",
  "tiny7": "registration-53018bea-tiny7-WXUgJq",
  "xwide8": "registration-53018bea-xwide8-WXUgJq",
  "wide6": "registration-53018bea-wide6-WXUgJq",
  "tiny6": "registration-53018bea-tiny6-WXUgJq",
  "gridContainer": "registration-53018bea-gridContainer-WXUgJq",
  "wide10": "registration-53018bea-wide10-WXUgJq",
  "armstrongGridContainer": "registration-53018bea-armstrongGridContainer-WXUgJq"
};